import _regeneratorRuntime from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { useState, useContext } from 'react';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import { createContext } from 'react';
import { UsersService } from '../hooks/useFindUser';
export var UserContext = /*#__PURE__*/createContext({
  user: undefined,
  setUser: null,
  isLoading: false,
  currentMembership: undefined,
  setCurrentMembership: undefined
});
export default function useAuth() {
  var _useContext = useContext(UserContext),
      setUser = _useContext.setUser,
      setCurrentMembership = _useContext.setCurrentMembership;

  var _useState = useState(null),
      error = _useState[0],
      setError = _useState[1]; //set user


  var setUserContext = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(baseUrl) {
      var doRedirect,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              doRedirect = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
              _context.next = 3;
              return new UsersService().me(baseUrl).then(function (user) {
                var trustedUser = user.memberships.find(function (membership) {
                  return membership && membership.userId === user.id;
                });
                setCurrentMembership && setCurrentMembership(trustedUser);
                setUser(user);
              })["catch"](function (err) {
                setUser(null);
                setError(err.response.data);
              });

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function setUserContext(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    setUserContext: setUserContext,
    error: error
  };
}